@if(activeVoyage().id){
<div class="o-layout__header c-header">
    <app-voyage-header [activeVoyage]="activeVoyage()" [activeRouteView]="activeRouteView()"
        (changeRouteView)="onChangeRouteView($event)" />

    <div class="c-header__nav">
        @if(activeVoyage().portCalls.length){
        <app-voyage-route [activeVoyage]="activeVoyage()" [activePortCall]="activePortCall()"
            [nextPortCall]="nextPortCall()" [activeRouteView]="activeRouteView()" (addPortCall)="onAddPortCall($event)"
            (editPortCall)="onEditPortCall($event)" (deletePortCall)="onDeletePortCall($event)"
            (changePortcallAsActive)="onChangePortcallAsActive($event)" (changeStatus)="onUpdatePortCallStatus($event)"
            (addExpensesAction)="onManagePda($event)"
            (addSpeedSelectionAction)="onAddSpeedSelection($event)" (speedSelectionUpdated)="onSpeedSelectionUpdated($event)"
            (editNauticalMileDistance)="onEditNauticalMileDistance($event)" />
        } @else {
        <app-voyage-routes-placeholder (addPortCall)="onAddPortCall()" />
        }
    </div> <!-- .c-header__nav -->
</div> <!-- .c-header -->


<!-- ! STOP: Header Start -->
@if(activeVoyage().portCalls.length){
<div class="c-stop-header">

    <h2 class="c-stop-header__heading u-heading">{{ 'voyage.portCallTitle' | translate }}</h2>

    <app-voyage-portcall-nav [activeVoyage]="activeVoyage()" [activePortCall]="activePortCall()"
        (changePortcallAsActive)="onChangePortcallAsActive($event)" />

    <app-voyage-portcall-nav-current [currentPortCall]="currentPortCall()"
        (changePortcallAsActive)="onChangePortcallAsActive(currentPortCall())" />

</div> <!-- .c-stop-header -->
}
<!-- ! STOP: Header End -->

<div class="o-grid u-push-t--xl">

    @if(activeVoyage().portCalls.length){
    <!-- ! Information -->
    <core-card class="c-stop-info o-grid__col">
        <app-voyage-details [activeVoyage]="activeVoyage()" [activePortCall]="activePortCall()"
            [activeExpenses]="activeExpensesSegment()" [activePda]="activePda()" (setArrival)="onPatchPortCall($event)"
            (setDeparture)="onPatchPortCall($event)" (viewPdaBreakdown)="onManagePda(activePortCall()!)">
        </app-voyage-details>
    </core-card>

    <!-- ! Progress -->
    <core-card class="c-stop-progress o-grid__col">
        <app-voyage-used [activeVoyage]="activeVoyage()" [activeVoyageSegment]="activeSegment()"
            [arrivalVoyageSegment]="arrivalSegment()" [departureVoyageSegment]="departureSegment()"
            (changeVoyageSegmentActive)="onChangeVoyageSegmentAsActive($event)" />
    </core-card>
    }

    <!-- ! Bookings -->
    <core-card class="c-stop-bookings o-grid__col o-grid__col--full">
        <h3 class="c-stop-heading u-heading">{{ 'voyage.bookingList' | translate }}</h3>
        <core-generic-table class="c-table--scroll" [columns]="bookingListTableConfig" [actions]="[]"
            [dataInput]="bookingList()" [modalFields]="[]" [enablePagination]="false" />
    </core-card>
</div> <!-- .o-grid -->
}

<core-generic-modal [isOpen]="!!portCallsModalState()" [title]="'voyage.portCallModal' | translate"
    [mode]="portCallsModalState() ?? modalmodes.CREATE" [fields]="portCallsModalConfig()"
    [modelFactory]="portCallModelFactory" [data]="activePortCallModal()" (close)="onClosePortCall()"
    (save)="onSavePortCall($event)">
</core-generic-modal>

<app-port-call-pda
    [portCall]="activePortCallModal()"
    [isOpen]="pdaModalOpen()"
    (closed)="onPdaModalClosed()"
    (pdaUpdated)="onPdaUpdated()">
</app-port-call-pda>

<core-generic-modal [isOpen]="!!speedSelectionModalState()" [title]="'voyage.confirmSpeedSelectionTitle' | translate"
    [mode]="speedSelectionModalState() ?? modalmodes.EDIT" [fields]="speedSelectionConfig()" [modelFactory]="portCallModelFactory"
    [data]="activePortCallModal()" (close)="onCloseSpeedSelection()" (save)="onSaveSpeedSelection($event)">
</core-generic-modal>

<core-generic-modal [isOpen]="!!nauticalMilesModalState()" [title]="'voyage.editNauticalMilesTitle' | translate"
    [mode]="nauticalMilesModalState() ?? modalmodes.EDIT" [fields]="nauticalMilesConfig()"
    [modelFactory]="portCallModelFactory" [data]="activePortCallModal()" (close)="onCloseNauticalMiles()"
    (save)="onSaveNauticalMiles($event)">
</core-generic-modal>

<ng-template #chasisTemplate let-row let-column="column">
    @if (!row.chasis || row.chasis.length === 0) {
    <span class="c-tag">{{ ' - ' }}</span>
    } @else if(row.chasis.length > 1){
    <span class="c-tag">{{ 'bookings.chasisAttached' | translate }}</span>
    } @else {
    <span class="c-tag">{{ row.chasis }}</span>
    }
</ng-template>

<ng-template #patchPortCall let-service="row">
    <div class="c-entry-group">
        <ng-container coreDynamicField [field]="portCallsDatesConfig()" [value]="portCallsDateModal()"
            [mode]="modalmodes.CREATE" (valueChange)="onPortCallDateChange($event)"></ng-container>
    </div>
</ng-template>
